import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import Divider from "components/ui/divider"
import Image from "components/ui/image"
import {
  IS_NA,
  IS_JEWLR,
  IS_INT,
  jewlr_t,
  getGlobalECookieData,
} from "helpers/application"
import { to_currency } from "helpers/number"

import CheckoutButton from "./checkout-button"
import { Panel, TitleDivider } from "./components"

const OrderSummary = ({ refs }) => {
  const summary = useSelector((state) => state.cart.summary)

  let currencyCode = summary.currency_code
  if (IS_INT()) {
    const globalEData = getGlobalECookieData()
    currencyCode = globalEData?.currencyCode || ""
  }

  return (
    <Panel className="tablet:pb-24 pb-10">
      <div className="text-14 leading-21 font-bold" ref={refs.cartSummaryRef}>
        <TitleDivider className="mb-10">
          <div className="flex items-center gap-8">
            <Image
              alt={`${jewlr_t("Cart")} Summary`}
              className="tablet:h-(--tablet-height) h-(--base-height)"
              height="18"
              src={require("images/icons/cart_black.svg")}
              style={{
                "--base-height": "18px",
                "--tablet-height": "22px",
                width: "24px",
              }}
              width="25"
            />
            <h3 className="text-20 leading-22 font-bold">
              {jewlr_t("Cart")} Summary
            </h3>
          </div>
        </TitleDivider>
        <Divider className="tablet:block bg-grey-20 my-10 hidden" />
        <div className="flex justify-between py-8">
          <p>Item Subtotal</p>
          <p data-ge-basket-subtotals>{summary.order_total}</p>
        </div>
        {summary.promo_code?.promo_code_applied && (
          <div className="flex justify-between">
            <p className="text-green-darker">
              Promo Code: {summary.promo_code.promo_code_applied}
            </p>
            <p
              className="text-green-darker"
              data-cy="cart-promo-code-price"
              data-ge-basket-discounts
            >
              {to_currency(summary.promo_code.promo_code_discount_amount, {
                precision: 2,
              })}
            </p>
          </div>
        )}
        {summary.bmsm_discount !== 0 && (
          <>
            <div className="flex justify-between pt-8">
              <p className="text-green-darker">Buy More Save More Discount</p>
              <p className="text-green-darker">
                {to_currency(summary.bmsm_discount, { precision: 2 })}
              </p>
            </div>
            <p className="text-grey-65 text-12 leading-12">
              {summary.bmsm_percentage}% off items {summary.bmsm_message}
            </p>
          </>
        )}
        {summary.promotion_discount !== 0 && (
          <>
            <div className="flex justify-between pt-8">
              <p className="text-green-darker">
                {summary.promotion_description}
              </p>
              <p className="text-green-darker">
                {to_currency(summary.promotion_discount, {
                  precision: 2,
                })}
              </p>
            </div>
            <p className="text-grey-65 text-12 leading-12">
              {summary.promotion_percentage}% off items{" "}
              {summary.promotion_message}
            </p>
          </>
        )}
        {IS_NA() && (
          <div className="flex justify-between pt-8">
            <p className="text-grey-62">Sales Tax</p>
            <p className="text-grey-62 font-medium">Calculated at checkout</p>
          </div>
        )}
        <Divider className="bg-grey-20 my-10" />
        <div className="pb-18 flex justify-between pt-8">
          <p>Estimated Total</p>
          <p data-ge-basket-totals>
            {summary.total} {currencyCode}
          </p>
        </div>
      </div>
      <CheckoutButton refs={refs} />
      {IS_JEWLR() && (
        <p className="tablet:text-8 tablet:font-normal text-11 text-grey-500 mt-24 text-center font-medium">
          JEWLR USES TRANSPORT LAYER SECURITY (TLS) ENCRYPTION.
        </p>
      )}
    </Panel>
  )
}

OrderSummary.propTypes = {
  refs: PropTypes.object,
}

export default OrderSummary
